import React, {useEffect, useState} from 'react';
import CustomSelect from "../form/CustomSelect";
import {GetReportTypes} from "../../api/reports/getReportTypes";
import {useTranslation} from "react-i18next";
import { REPORT_TYPE_MAP } from '../../config/variables';

const ReportTypeSelect = (props) => {

    const { t } = useTranslation();

    const [availableOptions, setAvailableOptions] = useState([]);

    useEffect(() => {
        const setReportTypes = async function (){
            try {
                const {data} = await GetReportTypes();
                let availableReports = [];
                Object.entries(data).forEach(([key, value]) => {
                    // const reportName = key.replace('_report_enabled', '');
                    const reportName = REPORT_TYPE_MAP[key];

                    if (value === true && reportName) {
                        availableReports.push({
                            value: reportName,
                            label: reportName.charAt(0).toUpperCase() + reportName.slice(1).replaceAll('_', ' ')
                        });
                    }
                });
                setAvailableOptions(availableReports);
            } catch (err){
                console.log("Error fetching report types: " + err);
            }
        }
        setReportTypes();
    }, []);

    return (
        <CustomSelect
            placeholder={<div>{t("Select report type")}</div>}
            options={availableOptions}
            onChange={props.onChange}
            value={availableOptions.find(option => option.value && props.value && option.value === props.value.toLowerCase())}
        />
    );
};

export default ReportTypeSelect;
